import React from 'react';
import ReactDOM from 'react-dom';

// or
import { GoogleLogin } from 'react-google-login';
import Swal from 'sweetalert2';
import { Modallogin } from './Modallogin';
import Testimonioregistrese from './Testimonioregistrese';


const Registrese = () => {
 
  
    return (
    <div>
<Testimonioregistrese/>

<Modallogin/>


    </div>
  )
}

export default Registrese